import DecimalForConceptos from "./DecimalForConceptos";
import DecimalAmount from "../../../../support/DecimalAmount";

class ConceptoBaseCalculator {

  data = {}

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new ConceptoBaseCalculator(data);
  }

  get() {
    const discount = parseFloat(this.data.Descuento) || 0;
    const subtotal = (parseFloat(this.data.Cantidad) * parseFloat(this.data.ValorUnitario)) - discount;

    return DecimalAmount.make(subtotal).floor(DecimalForConceptos.decimales).get();
  }

  getNeto() {
    const subtotal = (parseFloat(this.data.Cantidad) * parseFloat(this.data.ValorUnitario));

    return DecimalAmount.make(subtotal).floor(DecimalForConceptos.decimales).toFixed(DecimalForConceptos.decimales);
  }
}

export default ConceptoBaseCalculator;